import { useCallback, useMemo } from 'react';
import { LogisticTypeKeys, ShippingServiceType } from '@/Enums';
import { Icons } from '@/Static/IconsRes';
import { useLocalization } from '@/Hooks';
import { Logos } from '@/Static';

export const useLogisticProductIcons = () => {
  const iconsMap = useMemo((): { [key in LogisticTypeKeys]: string } => {
    return {
      [LogisticTypeKeys.ShipCheaper]: Logos.ShipCheaper,
      [LogisticTypeKeys.Dpd]: Logos.Dpd,
      [LogisticTypeKeys.Dhl]: Logos.Dhl,
      [LogisticTypeKeys.Hermes]: Logos.Hermes,
      [LogisticTypeKeys.Gls]: Logos.Gls,
      [LogisticTypeKeys.Ups]: Logos.Ups,
      [LogisticTypeKeys.DeutschePost]: Logos.DeutschePost,
      [LogisticTypeKeys.DhlExpress]: Logos.Dhl,
      [LogisticTypeKeys.DeutschePostMarke]: Logos.DeutschePost,
      [LogisticTypeKeys.Tnt]: Logos.Tnt,
    };
  }, []);

  const getLogisticProductIconByType = useCallback(
    (logisticType: LogisticTypeKeys) => {
      return iconsMap[logisticType];
    },
    [iconsMap],
  );

  return {
    getLogisticProductIconByType,
  };
};

export const useShippingServiceIcons = () => {
  const {
    modalWindows: {
      orderLinkWithProduct: {
        ShippingContract: { Curier, Pickup },
      },
    },
  } = useLocalization();

  const iconsMap = useMemo((): { [key in ShippingServiceType]: { type: string; icon: string }[] } => {
    return {
      [ShippingServiceType.PickupToPickup]: [
        { type: Pickup, icon: Icons.Pickup },
        { type: Pickup, icon: Icons.Pickup },
      ],
      [ShippingServiceType.PickupToCurier]: [
        { type: Pickup, icon: Icons.Pickup },
        { type: Curier, icon: Icons.Curier },
      ],
      [ShippingServiceType.CurierToCurier]: [
        { type: Curier, icon: Icons.Curier },
        { type: Curier, icon: Icons.Curier },
      ],
      [ShippingServiceType.CurierToPickup]: [
        { type: Curier, icon: Icons.Curier },
        { type: Pickup, icon: Icons.Pickup },
      ],
    };
  }, [Curier, Pickup]);

  const getShippingServiceIconByType = useCallback(
    (shippingService: ShippingServiceType) => {
      return iconsMap[shippingService];
    },
    [iconsMap],
  );

  return {
    getShippingServiceIconByType,
  };
};
